import SDKMessageBus from '../utility/message-bus';
import { Maybe } from 'maybe-not';

export default function promptForMFA(
    messageBus: SDKMessageBus,
    moduleId: string,
    platformCapabilities: Set<string>
) {
    if (!platformCapabilities.has('promptForMFA')) {
        return;
    }

    return function(): Promise<void> {
        return messageBus
            .sendRequest<void>('promptForMFA', Maybe.just(JSON.stringify({ moduleId })))
            .then(() => {
                return;
            })
            .catch(response => {
                throw new Error(response.message);
            });
    };
}
